var provisionnominaconpagosSucursalesSchema = {
  id: 'number',
  total: 'number',
  ventas: {
    id: 'number',
    costo_iva_venta: 'number',
    familia: {
      id: 'number',
    },
  },
}

function ProvisionnominaconpagosSucursalesService ($http) {
  this.get = function (nominas) {
    return $http.get('/api/nominas/polizas/provisionnominaconpagossucursales', {
      params: {nominas: nominas},
      schema: provisionnominaconpagosSucursalesSchema,
    })
  }
}

angular.module('contabilidad.polizasexternas')
  .service('ProvisionnominaconpagosSucursales', ProvisionnominaconpagosSucursalesService)



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/PolizasExternasProvisionnominasconpagossucursales.js